
<script>

import './style.scss'
import {mapState} from "vuex";
export default {
    props: {
        params: {
            type: Object,
            default: []
        },
        rules: {
            type: String,
            default: ''
        },
        full: {
            type: Object,
            default: () => {},
        }
    },
    data: function () {
        return {
            res: this.f,
            options:   this.params.options ?? [],
            filter:   this.params.filter ?? {},
            storedItem: this.params.store ?? null,
            disabled: this.params.disabled ?? false,
        }
    },

    computed: {
        ...mapState({
            cityOptions: state => state.dictionary.cityOptions,
            localityOptions: state => state.dictionary.localityOptions,
            districtOptions: state => state.dictionary.districtOptions,
            metroOptions: state => state.dictionary.metroOptions,
            areaOptions: state => state.dictionary.areaOptions,
            typeOptions: state => state.dictionary.typeOptions
        }),
        rulesComputed (){
            if (this.rules === ''){
                return '';
            }
            return this.rules.split('|').reduce((a, v) => {
                if(v.indexOf(':') >= 0){
                    return { ...a, [v.slice(0, v.indexOf(':'))]: v.slice(v.indexOf(':') + 1)}
                }else {
                    return { ...a, [v]: true}
                }
            }, {})
        },
    },
    watch: {
      res: {
        deep: true,
        handler: function(value) {
          this.$emit('update:f', value)
        }
      },
      f: {
        deep: true,
        handler: function(value) {
          this.res = this.full.oldImg ?? value;
        }
      },
    },
    methods: {
        getDict(dict){
            return this[dict];
        },
        toArr(item){return JSON.parse(item) ?? []},
        cloneArrToRes(source){
            this.res =_.clone(source);
        },
        isEqual: function (first, second){
            return _.isEqual(first, second);
        },
        strip_tags: function (str, allowed_tags) {
            var key = '', allowed = false;
            var matches = [];
            var allowed_array = [];
            var allowed_tag = '';
            var i = 0;
            var k = '';
            var html = '';

            var replacer = function (search, replace, str) {
                return str.split(search).join(replace);
            };

            // Build allowes tags associative array
            if (allowed_tags) {
                allowed_array = allowed_tags.match(/([a-zA-Z]+)/gi);
            }

            str += '';

            // Match tags
            matches = str.match(/(<\/?[\S][^>]*>)/gi);

            // Go through all HTML tags
            for (key in matches) {
                if (isNaN(key)) {
                    // IE7 Hack
                    continue;
                }

                // Save HTML tag
                html = matches[key].toString();

                // Is tag not in allowed list? Remove from str!
                allowed = false;

                // Go through all allowed tags
                for (k in allowed_array) {
                    // Init
                    allowed_tag = allowed_array[k];
                    i = -1;

                    if (i != 0) {
                        i = html.toLowerCase().indexOf('<' + allowed_tag + '>');
                    }
                    if (i != 0) {
                        i = html.toLowerCase().indexOf('<' + allowed_tag + ' ');
                    }
                    if (i != 0) {
                        i = html.toLowerCase().indexOf('</' + allowed_tag);
                    }

                    // Determine
                    if (i == 0) {
                        allowed = true;
                        break;
                    }
                }

                if (!allowed) {
                    str = replacer(html, "", str); // Custom replace. No regexing
                }
            }

            return str;
        },
         unescapeHTML: function(str) {
           return str.replace(/&#?(x)?([\w\d]{0,5});/gi, function (full, hex, code) {
            let HTMLFromEntityMap =   {
                   'lt':   '<',
                   'gt':   '>',
                   'amp':  '&',
                   'nbsp': ' ',
                   'quot': '"',
                   'apos': "'"
               }
        var special = HTMLFromEntityMap[code];
        return special || chr(hex ? parseInt(code, 16) : +code);
    });
}
    }

}
</script>
